import { BuyerCustomerDTO, DeliveryNoteDTO, Permission } from 'core/api';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import * as DeliveryNoteStore from './DeliveryNoteStore';

declare global {
	interface CommandType {
		updateDeliveryNoteCustomer: (note: DeliveryNoteDTO) => Promise<Result<BuyerCustomerDTO>>
	}
}

Command.register('updateDeliveryNoteCustomer', Preconditions.ensureIsNotLite, async (note: DeliveryNoteDTO): Promise<Result<BuyerCustomerDTO>> => {
	return Command.execute('setOrRemoveCustomer', {
		customer: note.Customer,
		setCustomer: async (customer: BuyerCustomerDTO) => await DeliveryNoteStore.changeCustomer(note.Id, customer),
		hideRemoveCustomerButton: true,
		requiredPermission: Permission.DeliveryNote_ChangeCustomer
	});
});
